import { z } from "zod";

export const ReturnToStoreFormSchema = z.object({
  returnToStoreActivated: z.boolean(),
});

export type ReturnToStoreFormValues = z.infer<typeof ReturnToStoreFormSchema>;

const OpeningTimeRangeSchema = z.object({
  from: z.string(),
  to: z.string(),
});

export const OpeningTimesSchema = z.array(OpeningTimeRangeSchema);

export type OpeningTimes = z.infer<typeof OpeningTimesSchema>;

export const StoreFormSchema = z.object({
  general: z.object({
    urlMap: z.string().optional(),
    embedMap: z.string().optional(),
    selectableByUser: z.boolean(),
    externalId: z.string().optional(),

    address: z.object({
      companyName: z.string(),
      contactName: z.string(),
      address1: z.string(),
      address2: z.string().optional(),
      city: z.string(),
      country: z.object({
        name: z.string(),
        code: z.string(),
      }),
      zip: z.string(),
    }),
  }),

  openingTimes: z.object({
    monday: OpeningTimesSchema,
    tuesday: OpeningTimesSchema,
    wednesday: OpeningTimesSchema,
    thursday: OpeningTimesSchema,
    friday: OpeningTimesSchema,
    saturday: OpeningTimesSchema,
    sunday: OpeningTimesSchema,
  }),
});

export type OpeningTimesDay = keyof StoreFormValues["openingTimes"];

export type StoreFormValues = z.infer<typeof StoreFormSchema>;
